import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { errorsMapping } from "../../mappers/mappers/errors-mapping.js";
import { mapExpressPaymentMethods } from "../../mappers/mappers/express-payment-methods.js";
import { GET_CART_EXPRESS_PAYMENT_METHODS } from "../../operations/queries/operations/queries/get-cart-express-payment-methods.js";
const useGetCartExpressPaymentMethods = () => {
  const [getCartExpressPaymentMethods, { called, loading, data, error }] = useLazyQuery(GET_CART_EXPRESS_PAYMENT_METHODS, {
    onError(error2) {
      console.error(error2);
      toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }
  });
  const getCartExpressPaymentMethodsMemoized = React.useCallback(
    (cartId) => {
      if (cartId) {
        getCartExpressPaymentMethods({ variables: { cartId } });
      }
    },
    [getCartExpressPaymentMethods]
  );
  return [
    getCartExpressPaymentMethodsMemoized,
    {
      data: mapExpressPaymentMethods(data?.cartExpressPaymentMethods),
      called,
      error,
      loading
    }
  ];
};
export {
  useGetCartExpressPaymentMethods
};
//# sourceMappingURL=use-get-cart-express-payment-methods.js.map
